export function TwilioLogo() {
  return <img src="https://ibis.vision/wp-content/themes/ripcord/assets/img/logo.png" alt="IbisVision" />;
}
